import { REDUX_STATUS } from '@gymaholic/packages'

/**
 * Checks whether the given instance is loaded/saved.
 * @param   {Instance} instance
 * @returns {boolean}
 */

function isLoaded (instance) {
  return instance && instance.status === REDUX_STATUS.SUCCESS
}

export default isLoaded
